/* Display-only Romanian letter substitutions for the FemiEko 2026 product templates. */
(() => {
  'use strict';
  const script = document.currentScript || document.getElementById('fe-pdp-romanian-typography');
  if (!script || !/^ro(?:[-_]|$)/i.test(script.dataset.locale || '') || window.feRomanianDisplayReady) return;
  const templates = new Set('absorbante-slim-2026|cupa-menstruala-safe-2026|cupa-powder-2026|disc-delicate-safe|disc-safe-2026|disc-universal-2026|eva-2026|flexi-2026|galaxy-2026|ida-black-2026|ida-teen-2026|kaia-2026|liners-2026|maja-2026|margaret-2026|nanna-2026|nora-2026|pads-2026|scarlett-2026|seamless-2026|tampons-2026|thea-2026'.split('|'));
  if (!templates.has(script.dataset.template)) return;
  window.feRomanianDisplayReady = true;

  const map = { '\u0219': 's', '\u021b': 't', '\u0218': 'S', '\u021a': 'T', '\u015f': 's', '\u0163': 't', '\u015e': 'S', '\u0162': 'T' };
  const letters = /[\u0218-\u021b\u015e\u015f\u0162\u0163]|[sStT][\u0326\u0327]/g;
  const normalize = value => value.replace(letters, letter => map[letter] || letter[0]);
  const scope = '#MainContent, .ch-sticky, .ch-quick';
  const excluded = 'script, style, template, noscript, textarea, code, pre, [contenteditable]:not([contenteditable="false"]), [data-fe-keep-diacritics]';
  const attributes = ['title', 'aria-label', 'placeholder', 'alt', 'label'];
  const observers = new Map();
  const generatedOptionLabels = new WeakMap();
  const queue = new Set();
  let scheduled = false;

  function allowed(element) {
    if (!element || !element.closest(scope) || element.closest(excluded)) return false;
    const language = element.closest('[lang]');
    return !language || /^ro(?:[-_]|$)/i.test(language.getAttribute('lang') || '');
  }

  function text(node) {
    const parent = node.parentElement;
    // Option labels are handled separately so implicit option values never change.
    if (!allowed(parent) || parent.closest('option')) return;
    const clean = normalize(node.nodeValue);
    if (clean !== node.nodeValue) node.nodeValue = clean;
  }

  function labels(element) {
    if (!allowed(element)) return;
    if (element.tagName === 'OPTION') {
      const generated = generatedOptionLabels.get(element);
      if (!element.hasAttribute('label') || (generated !== undefined && generated === element.getAttribute('label'))) {
        const clean = normalize(element.text);
        if (clean !== element.text || generated !== undefined) {
          generatedOptionLabels.set(element, clean);
          if (element.getAttribute('label') !== clean) element.setAttribute('label', clean);
        }
      } else generatedOptionLabels.delete(element);
    }
    for (const name of attributes) {
      if (name === 'label' && element.tagName !== 'OPTION' && element.tagName !== 'OPTGROUP') continue;
      if (!element.hasAttribute(name)) continue;
      const original = element.getAttribute(name);
      const clean = normalize(original);
      if (clean !== original) element.setAttribute(name, clean);
    }
  }

  function scan(node) {
    if (!node.isConnected) return;
    if (node.nodeType === Node.TEXT_NODE) { text(node); return; }
    if (node.nodeType !== Node.ELEMENT_NODE || !allowed(node)) return;
    labels(node);
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode(candidate) {
        if (candidate.nodeType === Node.ELEMENT_NODE) return allowed(candidate) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    while (walker.nextNode()) {
      if (walker.currentNode.nodeType === Node.TEXT_NODE) text(walker.currentNode);
      else labels(walker.currentNode);
    }
  }

  function changed(records) {
    for (const record of records) {
      if (record.type === 'childList') {
        for (const node of record.addedNodes) queue.add(node);
        // Changing option text can change its displayed label without changing attributes.
        if (record.target.nodeType === Node.ELEMENT_NODE && record.target.tagName === 'OPTION') queue.add(record.target);
      } else if (record.type === 'characterData' && record.target.parentElement?.tagName === 'OPTION') {
        queue.add(record.target.parentElement);
      } else queue.add(record.target);
    }
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      const nodes = Array.from(queue);
      queue.clear();
      for (const node of nodes) {
        if (!nodes.some(other => other !== node && other.nodeType === Node.ELEMENT_NODE && other.contains(node))) scan(node);
      }
    });
  }

  function attach() {
    for (const [root, observer] of observers) {
      if (!root.isConnected) { observer.disconnect(); observers.delete(root); }
    }
    for (const root of document.querySelectorAll(scope)) {
      if (Array.from(observers.keys()).some(existing => existing.contains(root))) continue;
      scan(root);
      const observer = new MutationObserver(changed);
      observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: attributes });
      observers.set(root, observer);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
  else attach();
  document.addEventListener('shopify:section:load', attach);
})();
